export const dovolenaProject: string = "ADMIN-TSK-Placená dovolená";
export const blokaceProject: string = "ADMIN-TSK-Blokace";
export const temporaryProject: string = "ADMIN-TSK-Temporary Project Activity holder";
